export const FUELS = {
  GOA: 'GOA',
  GOAPLUS: 'GOAPLUS',
  G95: 'G95',
  ADBLUE: 'AdBlue',
}
